import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';

function CollectionGrid() {
  const { caprisImage, shortsImage, shoesImage } = useStaticQuery(graphql`
    {
      caprisImage: file(relativePath: { eq: "capris.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 960) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shortsImage: file(relativePath: { eq: "shorts.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 960) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shoesImage: file(relativePath: { eq: "shoes.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 960) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  function Collection({ image, label, slug }) {
    return (
      <div className="relative bg-light-pink">
        <GatsbyImage fluid={image.childImageSharp.fluid} className="h-full" />
        <div className="absolute inset-0 flex p-4">
          <div className="flex items-end justify-center flex-1 p-4 border border-white">
            <Link
              to={slug}
              className="bg-white text-dark-pink button hover:bg-dark-pink hover:text-white focus:bg-dark-pink focus:text-white"
            >
              {label}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  Collection.propTypes = {
    image: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  };

  return (
    <article className="w-full max-w-xs px-4 mx-auto sm:px-6 lg:px-8 sm:max-w-2xl lg:max-w-7xl">
      <div className="grid gap-4 lg:grid-cols-3">
        <Collection
          image={caprisImage}
          label="Capris"
          slug="/collections/capris/"
        />
        <Collection
          image={shortsImage}
          label="Shorts"
          slug="/collections/shorts/"
        />
        <Collection
          image={shoesImage}
          label="Shoes"
          slug="/collections/shoes/"
        />
      </div>
    </article>
  );
}

export { CollectionGrid };
